import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';

import { DataService } from '../data.service';

declare var Nanobar: any;
declare var $: any;
declare var toastr: any;

@Component({
  selector: 'app-registered-vendors',
  templateUrl: './registered-vendors.component.html',
  styleUrls: ['./registered-vendors.component.css']
})
export class RegisteredVendorsComponent implements OnInit {

  searchCategory: string = ''
  vendorData: any[] = [];
  last_page: boolean = false;
  btnShowAfterLoad: boolean = true;
  
  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder
  ) {
    this.dataService.pageName = 'Registered Vendors';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
  }
  // registeredVendorForm: FormGroup = this.formBuilder.group({
  //   name: ['', Validators.required],
  //   email: ['', [Validators.required, Validators.email]]
  // });

  ngOnInit() {
    this.getRegisteredVendor();
  }

  getRegisteredVendor() {
    this.dataService.getRegisteredVendor(window.localStorage.getItem('token')).subscribe(
      data => {
        console.log(data);
      },
      err => {
        console.log(err);
      }
    )
  }

  filterSearch(){}

  // openAddRegisteredVendorPop() {
  //   $('.c-label label').css('color', '#3d3e3d');
  //   $('.c-label input').css('border-color', '#ccc');
  //   $('.c-label textarea').css('border-color', '#ccc');
  //   // this.productName = '';
  //   // this.description = '';
  //   $('#addRegisteredVendorPop').modal('show');
  // }

  // onSubmitRegisterForm() {
  //   this.registeredVendorForm.value.auth_token = window.localStorage.getItem('token');
  //   console.log(this.registeredVendorForm.value);
  //   this.dataService.addRegisteredVendor(this.registeredVendorForm.value).subscribe(
  //     data => {
  //       console.log(data);
  //     },
  //     err => {
  //       console.log(err);
  //     }
  //   );
  // }

}



// WEBPACK FOOTER //
// ./src/app/registered-vendors/registered-vendors.component.ts